export default {
  ESI_COOKIE: 1,
  ESI_TOY: 2,
  ESI_BELL: 3,
  ESI_SNOWMAN: 4,
  ESI_CUP: 5,
  ESI_POMEGRANATE: 6,
  ESI_ORANGE: 7,
  ESI_GRAPES: 8,
  ESI_PINEAPPLE: 9,
  ESI_BONUS: 10,
  ESI_BONUS_MINI: 11,
  ESI_BONUS_MAJOR: 12,
  ESI_BONUS_GRAND: 13,
}
